import { useEffect, useState } from "react";
import { Modal } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { updateParams, updateVideoPageState } from "../VideoActions";
import { X } from "react-feather";
import { operations } from "../../../Shared/modules/videoAssociations";
import { useParams } from "react-router-dom";

const SinglePublishMessage = ({ singleVideo, onClose, isVideoDetailPage }) => {
  const { video } = singleVideo || {};
  const [allPublished, setAllPublished] = useState(false);
  const dispatch = useDispatch();
  const videos = useSelector((state) => state.videos);
  const isPublished =
    video?.additional_data?.data?.published_to_swirl ===
    "Successfully updated published status";

  useEffect(() => {
    const video = videos?.map((data) => data?.video);
    const publishedData = video?.map(
      (data) => data?.additional_data?.data?.published_to_swirl
    );
    const isPublishedSwirlArray = Array.isArray(publishedData);
    const allVideosPublished =
      isPublishedSwirlArray &&
      publishedData.every(
        (status) => status === "Successfully updated published status"
      );
    setAllPublished(allVideosPublished);
  }, [videos]);

  const showSinleSwirll = useSelector(
    (state) => state.videoPageStates.showSinleSwirll
  );
  const publishVideosCheckList = useSelector(
    (state) => state.videoPageStates.publishVideosCheckList
  );

  const { id } = useParams();
  const closeModal = () => {
    onClose();
    dispatch(
      updateVideoPageState({
        showSinleSwirll: false,
        publishVideosCheckList: [],
      })
    );
    if (isVideoDetailPage) {
      dispatch(operations.fetchVideoAssociations(id));
      dispatch(updateParams({ reFetch: true }));
    } else {
      dispatch(updateParams({ reFetch: true }));
    }
  };

  const publishUnPublishIcon = (iconName) => (
    <img
      src={require(`@src/assets/images/vyrill/videos/${iconName}.png`).default}
      width={67}
    />
  );

  return (
    <Modal
      backdrop={false}
      contentClassName="single-publish-swirll-message"
      isOpen={showSinleSwirll}
    >
      <div className="cross-icon">
        <div onClick={closeModal} role="button">
          <X size={49} role="button" strokeWidth="1" />
        </div>
      </div>
      <div>
        {publishUnPublishIcon(
          isPublished || allPublished ? "unPublishedModal" : "publishedModal"
        )}
      </div>
      <div className="publish-unpublish">
        {isPublished || allPublished ? " Unpublished!" : "Published!"}{" "}
      </div>
      <div className="video-title">
        {publishVideosCheckList.length !== 0 ? (
          <div style={{ color: "black" }}>
            <b>{publishVideosCheckList.length} videos</b>{" "}
            {isPublished || allPublished
              ? "are no more live on"
              : "are now live on"}
          </div>
        ) : (
          <>Video: {video && video?.title ? video?.title : "No video title"}</>
        )}
      </div>
      <img
        src={require(`@src/assets/images/vyrill/videos/swirlLogo.png`).default}
        style={{ marginBottom: "100px" }}
        width={146}
        height={39}
      />
    </Modal>
  );
};

export default SinglePublishMessage;
